import React, { useState } from 'react';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import { AddButton, CancelButton, SubmitButton, UpdateButton } from '../../../components/mui/Buttons/Buttons';
import { useSelector } from 'react-redux';
import Loader3D from '../../../components/Loader/Loader3D';
import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { commonFileUpload, createPurchase, getPurchasedItems, updatePurchase } from '../../../redux/features/assetManagementSlice';
import { useNavigate } from 'react-router-dom';
import { savePaginationData } from '../../../redux/features/globalDatagridSlice';
import { uploadedFileUrl } from '../../../utils/constants/links';
const AddOrUpdatePurchase = ({
  row,
  quotationId,
  quotationStatusNotApproved,
  isEditable,
  isPurchased,
  dispatchParams,
}) => {
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { loading:mainLoading,fileUploadLoading } = useSelector((store) => store.assetmanagement);
  const loading=mainLoading || fileUploadLoading;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const initialValues = {
    purchaseDate: row ? dayjs(row.purchaseDate).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD'),
    expiryDate: row ? dayjs(row.expiryDate).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD'),
    warranty: row ? row.warranty : '',
    quotation: row ? row.quotation : quotationId,
    remarks: row ? row.remarks : '',
    color: row ? row.color : '',
    IdNumber: row ? row.idNumber : '',
    purchasedInvoiceBackendFileName: row ? row?.purchasedInvoiceFileName : '',
  };

  const schema = Yup.object().shape({
    // purchaseDate: Yup.date().required("Purchase Date is required"),
    // expiryDate: Yup.date().required("Expiry Date is required"),
    // warranty: Yup.string().required("Warranty is required"),
    // remarks: Yup.string().required("Remarks is required"),
    // color: Yup.string().optional("Color is required"),
    // IdNumber: Yup.string().optional("Product Id is required"),
    purchasedInvoiceBackendFileName: Yup.string().required('Purchased Invoice is required'),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      const data = { ...values };
      if (row) {
        const updateData = { ...data, id: row.purchaseID };
        dispatch(updatePurchase(updateData)).then((res) => {
          if (res.payload.status === 'error') {
            enqueueSnackbar(res.payload.message, {
              variant: 'error',
            });
          } else if (res.payload.status === 'success') {
            handleCancel();
            dispatch(getPurchasedItems(dispatchParams));
            dispatch(savePaginationData({ ...paginationData, openAnchor: false }));
            enqueueSnackbar(res.payload.message, {
              variant: 'success',
            });
          }
        });
      } else {
        dispatch(createPurchase(data)).then((res) => {
          if (res.payload.status === 'error') {
            enqueueSnackbar(res.payload.message, {
              variant: 'error',
            });
          } else if (res.payload.status === 'success') {
            handleCancel();
            navigate('/asset-management/purchase');
            enqueueSnackbar(res.payload.message, {
              variant: 'success',
            });
          }
        });
      }
    },
  });
  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };

  const uploadFile = async (file, dispatch) => {
    try {
      const formData = new FormData();
      formData.append('uploads', file);
      const response = await dispatch(commonFileUpload(formData));
      return response.payload?.data?.filename || '';
    } catch (error) {
      console.error('File upload failed:', error);
      return '';
    }
  };
  return (
    <GlobalDialog
      maxWidth={loading ? 'sm' : 'md'}
      fullWidth={true}
      title={'Purchase'}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <>
          {row ? (
            <UpdateButton size="small" action={() => setOpen(true)} disabled={false}>
              Update Product Details
            </UpdateButton>
          ) : (
            <AddButton
              size={'large'}
              action={() => {
                setOpen(true);
              }}
              disabled={quotationStatusNotApproved || isEditable || isPurchased}
            >
              Purchase
            </AddButton>
          )}
        </>
      }
      content={
        <>
          {loading ? (
            <Loader3D />
          ) : (
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Box>
                  <Stack gap={2}>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      id={'purchaseDate'}
                      type="date"
                      label="Purchased Date"
                      name={`purchaseDate`}
                      value={formik.values.purchaseDate}
                      onChange={formik.handleChange}
                      error={formik.touched.purchaseDate && Boolean(formik.errors.purchaseDate)}
                      helperText={formik.touched.purchaseDate && formik.errors.purchaseDate}
                      inputProps={
                        !row
                          ? {
                              min: new Date().toISOString().split('T')[0],
                            }
                          : {}
                      }
                    />
                    <TextField
                      autoComplete="off"
                      fullWidth
                      id={'expiryDate'}
                      type="date"
                      label="Expire Date"
                      name={`expiryDate`}
                      value={formik.values.expiryDate}
                      onChange={formik.handleChange}
                      error={formik.touched.expiryDate && Boolean(formik.errors.expiryDate)}
                      helperText={formik.touched.expiryDate && formik.errors.expiryDate}
                      inputProps={
                        !row
                          ? {
                              min: new Date().toISOString().split('T')[0],
                            }
                          : {}
                      }
                    />
                    <TextField
                      autoComplete="off"
                      fullWidth
                      id={'warranty'}
                      type="text"
                      label="Warranty"
                      name={`warranty`}
                      value={formik.values.warranty}
                      onChange={formik.handleChange}
                      error={formik.touched.warranty && Boolean(formik.errors.warranty)}
                      helperText={formik.touched.warranty && formik.errors.warranty}
                    />
                    {row && (
                      <>
                        <TextField
                          autoComplete="off"
                          fullWidth
                          id={'color'}
                          type="text"
                          label="Color"
                          name={`color`}
                          value={formik.values.color}
                          onChange={formik.handleChange}
                          error={formik.touched.color && Boolean(formik.errors.color)}
                          helperText={formik.touched.color && formik.errors.color}
                        />
                        <TextField
                          autoComplete="off"
                          fullWidth
                          id={'IdNumber'}
                          type="text"
                          label="Product Id"
                          name={`IdNumber`}
                          value={formik.values.IdNumber}
                          onChange={formik.handleChange}
                          error={formik.touched.IdNumber && Boolean(formik.errors.IdNumber)}
                          helperText={formik.touched.IdNumber && formik.errors.IdNumber}
                        />
                      </>
                    )}
                    <TextField
                      autoComplete="off"
                      fullWidth
                      id={'remarks'}
                      type="text"
                      label="Remarks"
                      name={`remarks`}
                      value={formik.values.remarks}
                      onChange={formik.handleChange}
                      error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                      helperText={formik.touched.remarks && formik.errors.remarks}
                    />

                    <Box>
                      <Button
                        disabled={row || loading}
                        variant="outlined"
                        component="label"
                        size="small"
                        sx={{ minWidth: 180 }}
                      >
                        {'Upload File'}
                        <input
                          type="file"
                          hidden
                          accept="image/*,.pdf"
                          onChange={async (e) => {
                            const newFile = e.target.files[0];
                            if (newFile) {
                              const fileKey = await uploadFile(newFile, dispatch);
                              if (fileKey) {
                                formik.setFieldValue(`purchasedInvoiceBackendFileName`, fileKey);
                              }
                            }
                          }}
                        />
                      </Button>

                      {/* 🔴 FORM ERROR DISPLAY */}
                      {formik.touched.purchasedInvoiceBackendFileName &&
                        formik.errors.purchasedInvoiceBackendFileName && (
                          <Typography sx={{ ml: 1 }} variant="caption" color="error">
                            {formik.errors.purchasedInvoiceBackendFileName}
                          </Typography>
                        )}

                      {formik.values.purchasedInvoiceBackendFileName && (
                        <>
                          {/* If PDF */}
                          {formik.values.purchasedInvoiceBackendFileName.toLowerCase().endsWith('.pdf') ? (
                            <Box mt={1}>
                              <iframe
                                src={`${uploadedFileUrl}/${formik.values.purchasedInvoiceBackendFileName}`}
                                width="200"
                                height="150"
                                title="Uploaded PDF"
                                style={{ border: '1px solid #ccc', borderRadius: 4 }}
                              ></iframe>
                            </Box>
                          ) : (
                            /* Otherwise render Image */
                            <Box mt={1}>
                              <img
                                src={`${uploadedFileUrl}/${formik.values.purchasedInvoiceBackendFileName}`}
                                alt="Uploaded File"
                                width={200}
                                height={150}
                                style={{ objectFit: 'contain', border: '1px solid #ccc', borderRadius: 4 }}
                              />
                            </Box>
                          )}
                        </>
                      )}
                    </Box>
                  </Stack>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Stack direction={'row'} spacing={1}>
                      <CancelButton action={() => handleCancel()}>Cancel</CancelButton>
                      {row ? (
                        <UpdateButton disabled={loading} type="submit">
                          {loading ? 'Updating...' : 'Update'}
                        </UpdateButton>
                      ) : (
                        <SubmitButton disabled={loading} type="submit">
                          {loading ? 'Submiting...' : 'Submit'}
                        </SubmitButton>
                      )}
                    </Stack>
                  </Box>
                </Box>
              </Form>
            </FormikProvider>
          )}
        </>
      }
    />
  );
};

export default AddOrUpdatePurchase;
